import { render, staticRenderFns } from "./OtploginMynt.vue?vue&type=template&id=b47f3bfe&"
import script from "./OtploginMynt.vue?vue&type=script&lang=js&"
export * from "./OtploginMynt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports